export default __webpack_public_path__ + "static/media/Solar Energy_ΗΛ.fe280976.png";